import React from 'react'
import CanadaTemplateDefault from 'src/components/template/ca/'
import { useEPLImage } from 'src/modules/hooks/useEPLImage'
import { promoCodes } from 'src/constants/promoCodes'
import { canadaPlanSet } from 'src/constants/planData/canadaPlanData'

export default (props) => {
  const posterImg = useEPLImage()

  return (
    <CanadaTemplateDefault
      location={props.location}
      lang="en"
      market="canada"
      offerBanner={{
        title: ['Special Offer Applied!', 'Enjoy your first month of Fubo for only $9.99.'],
      }}
      offerCode={promoCodes.canada_lenovo}
      ctaText="Get Access"
      poster={posterImg}
      noVideo={true}
      pageTitle="Watch the Premier League all season"
      title={
        <>
          Watch the Premier League <span className="desktop-line-break">all season</span>
        </>
      }
      subtitle="Live games available in 4K Ultra HD. Streaming exclusively on Fubo."
      networkSet="canada"
      logo="https://assets-imgx.fubo.tv/marketing/lp/images/partners/logo-lockup-epl-white.png?ch=width&auto=format,compress"
      logoHeight="90px"
      hasPlanCardsTabs={false}
      planCardsConfig={{
        plans: canadaPlanSet.sports,
      }}
      noIndex={true}
    />
  )
}
